_ = require('lodash')
{partitionAndSort} = require('../../utils')

module.exports = (
  $anchorScroll,  # AR-11871
  $location,  # AR-11871
  $scope,
  $rootScope,
  $stateParams,
  $state,
  $log,
  $uibModal,
  filterFilter,
  endpoints,
  countries,
  project,
  starredDocs,
  workflows,
  allWorkflowSteps,
  polling,
  DataConcierge
  manualSteps,
  settings,
  states,
  ProjectStarredDocuments,
  SearchResult,
  Api,
) ->

  # This is the 1st controller of a four tier system:
  # 1. Project layer: contains the project and all of the workflows and their steps
  # 2. Workflow layer: selects the workflow and it's steps out of cached project data
  # 3. The step layer contains the step and any iterations
  # 4. The results layer contains the information specific to the type of result

  {projectId, workflowId, stepId, iterationId} = $stateParams

  # =========================
  # -------- Actions --------
  # =========================

  $scope.requestSupport = ( comment ) ->
    requestModal = $uibModal.open
      template: require('../ResearchRequestModal/research-request.html')
      controller: 'ResearchRequestModalController'
      size: 'lg'
      resolve:
        workflowStep: () ->
          return $scope.step
        comment: () ->
          comment

    requestModal.result.then (researchRequest) ->
      if researchRequest
        $scope.researchRequests.push researchRequest

        $uibModal.open
          template: require('../ResearchRequestModal/received.html')
          size: 'lg'
          controller: 'ReceivedController'

  $scope.requestDataConciergeForManualSource = ( workflow, workflowStep, manualStep ) ->
    sourceWorkflowPairs = [{
      source: manualStep.name
      term:   workflow.query
    }]
    DataConcierge.showManualSourceRequestModal( sourceWorkflowPairs ).then ( extra ) ->
      DataConcierge.addManualStepRequest( workflow, workflowStep, manualStep, extra ).then ( request ) ->
        manualStep.request = request

  # =========================
  # -------- Display --------
  # =========================

  $scope.checkStepNotApplicable = (step) ->
    return step.not_applicable

  $scope.checkStepComplete = (step) ->
    return step.complete

  $scope.checkStepCompletedAutomatically = (step) ->
    return step.complete and step.automatically_marked_complete

  $scope.checkStepCompletedManually = (step) ->
    return step.complete and !step.automatically_marked_complete

  $scope.stepIndex = (add) ->
    index = (i for s, i in $scope.steps when s.id is $scope.step?.id)[0]
    return if index? then index + add else undefined

  # =========================
  # ---------Select ---------
  # =========================

  $scope.setCurrentStep = (stepId) ->
    if not $scope.allSteps[stepId]
      $rootScope.error = "The step that you were on is not visible in the current state."
      $state.go('start')
      return
    $scope.step = $scope.allSteps[stepId][0]

  $scope.setResearchRequests = (researchRequests) ->
    $scope.researchRequests = researchRequests

  $scope.setAllStepWorkflows = (steps) ->
    $scope.allWorkflowSteps = partitionAndSort(steps, 'workflow', 'order')

  # to be set by WorkflowController
  $scope.setSteps = (steps) ->
    $scope.steps = steps

  $scope.setWorkflow = (workflow) ->
    $scope.workflow = workflow

  $scope.setWorkflows = (workflows) ->
    $scope.workflows = workflows

  # =========================
  # ------ Navigation -------
  # =========================

  $scope.selectNext = () ->
    if $scope.steps and $scope.workflows
      nextStep = $scope.steps[$scope.stepIndex(1)]
      nextWorkflow = $scope.workflows[$scope.workflows.indexOf($scope.workflow) + 1]
      nextState = undefined
    if not nextStep and not nextWorkflow
      if $scope.hasManualSteps and _.some($scope.workflows, manual_check_warnings: true)
        nextState = 'project.manual'
      else
        nextState = 'project.export'

    $scope.moveState(nextStep, nextWorkflow, nextState)

  $scope.moveState = (nextStep, nextWorkflow, state) ->
    # If we have more workflow steps, go to next
    # If we have more workflows, go to next
    # Else go to project review
    if state
      params =
        projectId: $scope.project.id
    else if nextStep?
      params =
        projectId: $scope.project.id
        workflowId: $scope.workflow?.id or nextWorkflow.id
        workflowStepId: nextStep.id
      state = 'project.workflow.step'
    else if nextWorkflow?
      params =
        projectId: $scope.project.id
        workflowId: nextWorkflow.id
      state = 'project.workflow'
    else
      $log.error('Couldn\'t find which state to move to')
    $state.go(state, params)

  # =========================
  # -------- Polling --------
  # =========================

  $scope.starredDocPolling = ->
    startPolling = () ->
      mergeKey = (doc) ->
        if doc.search_result then '__SEARCH_RESULT_ID__' + doc.search_result else '__PSD_ID__' + doc.id
      starredDocsCollection.poll {project: project.id}, 20000, mergeKey, () ->
        updateStarredDocs()
    startPolling()

    $scope.$on '$destroy', ->
      starredDocsCollection.stopPolling()


  # =========================
  # --------- Scope ---------
  # =========================

  # initial values from the resolver
  $scope.project = project

  decorate = (doc) ->
    if doc.result
      SearchResult.decorate(doc.result)
    return doc

  updateStarredDocs = () ->
    $scope.starredDocs ?= {}
    $scope.starredDocsByFingerprint ?= {}
    for starredDoc in starredDocsCollection
      decorate(starredDoc)
      # The "results" shown in the UI can be either search results or uploaded
      # documents. The uploaded documents are actually starredDocs objects so
      # they are always in the starredDocsCollection (which represents the
      # contents of the workflow_projectstarredocuments table). The search
      # results shown in the UI come from the backend_searchresult table and
      # may or may not have an associated starredDoc. We use this dict to make
      # it easy to find the starredDoc for a given "result" from the UI
      # whether it is a search result or an uploaded document. When searching
      # for a uploaded document in this table, since it _is_ already a
      # starredDoc, the ID will be that of the starredDoc. While when searching
      # for a search result, the ID will be that of the search result. That is
      # why we index the starredDocs that reference a search result by the ID
      # of their search result. [Of course this is a hack, could even cause
      # clashes, and is liable to bugs... I have no idea what the developers
      # of that time were thinking...]
      $scope.starredDocs[ starredDoc.search_result or starredDoc.id ] = starredDoc
      if starredDoc.result and starredDoc.result.fingerprint
        $scope.starredDocsByFingerprint[ starredDoc.result.fingerprint ] = starredDoc

    # Used by findings (step and findings)
    projectStarredDocs = partitionAndSort( starredDocsCollection, 'workflow_step', 'id' )
    $scope.projectStarredDocs = {}
    for key, step of projectStarredDocs
      $scope.projectStarredDocs[ key ] = {}
      for starredDoc in step
        $scope.projectStarredDocs[ key ][ starredDoc.search_result or starredDoc.id ] = starredDoc

  $scope.starredDocs = {}
  $scope.starredDocsByFingerprint = {}
  starredDocsCollection = ProjectStarredDocuments.decorate(starredDocs)
  updateStarredDocs()

  $scope.manualUploads = partitionAndSort(starredDocs, 'manual_source', 'id')

  $scope.workflows = workflows
  $scope.allWorkflowSteps = partitionAndSort(allWorkflowSteps, 'workflow', 'order')
  $scope.allSteps = partitionAndSort(allWorkflowSteps, 'id', 'order')
  $scope.countries = countries
  $scope.manualSteps = manualSteps
  $scope.hasManualSteps = manualSteps.length > 0
  $scope.states = states

  $scope.selectedDocs = {}

  $scope.numberOfSelectedDocs = () ->
    _.size($scope.selectedDocs)

  $scope.unselectAllDocs = () ->
    $scope.selectedDocs = {}

  $scope.setIsDocSelected = (doc, isSelected) ->
    if isSelected
      $scope.selectedDocs[doc.id] = isSelected
    else
      delete $scope.selectedDocs[doc.id]

  $scope.getIsDocSelected = (doc) ->
    doc?.id of $scope.selectedDocs

  $scope.allDocsSelected = (docsOnPage) ->
    if $scope.numberOfSelectedDocs() == docsOnPage.length
      return true
    else if $scope.numberOfSelectedDocs() == 0
      return false

    # for indeterminate state in checkbox
    return undefined

  $scope.toggleSelectedDocs = (docsOnPage) ->
    if $scope.allDocsSelected(docsOnPage)
      $scope.unselectAllDocs()
    else
      for doc in docsOnPage
        $scope.setIsDocSelected(doc, true)

  $scope.annotateDoc = (doc, annotation) ->
    newComment = new Api.Comment
      content: annotation
      content_type: 'projectstarreddocument'
      document_pk: doc.id

    newComment.$save().then (comment) ->
      doc.comments.push(comment)

  $scope.saveSelectedDocsTags = (docsOnPage, tagIdsToSave, annotation) ->
    for doc in docsOnPage.filter($scope.getIsDocSelected)
      $scope.saveDocTags(doc, tagIdsToSave).then (starredDoc) ->
        if annotation
          $scope.annotateDoc(starredDoc, annotation)
    $scope.unselectAllDocs()

  $scope.newStarredResult = (result, starProperties) ->
    resultProperties =
      title:          result.title or 'Untitled'
      link:           result.url
      snippet:        result.snippet
      extra:          result.extra or ''
      workflow_step:  $scope.step.id
      project:        $scope.project.id
      search_result:  result.id

    angular.extend( resultProperties, starProperties )

    newStarredDoc = $scope.newStarredDoc(resultProperties)

    newStarredDoc.$save().then(decorate)

  $scope.alreadyHasStarredDoc = (doc) ->
    # Returns whether the document already has an associated starredDoc.
    # `doc` is a "result" shown in the UI, eg: may be a SearchResult or a
    # uploaded document. Uploaded documents in the UI are a starredDoc
    # themselves so this should always return true regardless of whether they
    # are already dispositioned. Search results will return true only if
    # they have already been dispositioned and the corresponding starredDoc
    # is in the list.
    return angular.isDefined $scope.starredDocs[ doc.id ]

  $scope.isSearchResult = (doc) ->
    # This function distinguishes between a regular result and a starredDoc.
    # A regular result does not have the 'search_result' property,
    # while a starredDoc contains this property (though it may be an empty value).
    return 'search_result' not of doc


  $scope.newStarredDoc = (data) ->
    doc = starredDocsCollection.newRecord(data)
    updateStarredDocs()
    return doc

  $scope.getStarredDoc = (doc) ->
    # Returns the starredDoc for a given document.
    # `doc` is a "result" shown in the UI, eg: may be a SearchResult or an
    # uploaded document. A uploaded document is actually a starredDoc, so it
    # will return itself. For a search result that has been dispositioned it
    # will return the starredDoc containing its disposition.
    return $scope.starredDocs[ doc.id ]

  $scope.updateStarredDoc = (doc) ->
    $scope.getStarredDoc(doc).$update().then(decorate)

  $scope.removeStarredDoc = (doc) ->
    starredDocsCollection.removeRecord(doc)
    updateStarredDocs()

  $scope.saveDocTags = (doc, documentTagIdsToSave) ->
    if $scope.alreadyHasStarredDoc(doc)
      # this might be a SearchResult or uploaded document
      $scope.getStarredDoc(doc).tags = documentTagIdsToSave
      $scope.updateStarredDoc(doc)
    else if $scope.isSearchResult(doc)
      # Uploading a document adds it to starredDocs automatically.
      # If a document is not in starredDocs, it must be a SearchResult.
      # Previously, there was a bug where a starredDoc was created with the ID of
      # another starredDoc. Although this bug no longer exists, we leave this check
      # in place as a precaution in case it resurfaces.
      $scope.newStarredResult(doc, {
        tags: documentTagIdsToSave
      })
    else
      $rootScope.error = "Tags cannot be saved, please reload this page and try again."
      $location.hash('error-message')
      $anchorScroll()


  $scope.countryById = (countryId) ->
    _.find(countries, {id: countryId})

  $scope.getSearchCountries = (iteration) ->
    if iteration
      return (c for c in $scope.countries when c.id in iteration.base_countries and c.iso_code isnt 'glo')
    return []

  $scope.getCountriesToolTip = (step, iteration) ->
    matchingCountries = (c.name for c in $scope.getSearchCountries(iteration))
    toolTip = "This step searches sources specified for " + matchingCountries.join(", ")

    if step.search_scope == "search_country"
      return toolTip

    return toolTip + " and specified international sources"

  $scope.checkStepIsStillVisible = (steps) ->
    if $scope.step and $scope.step.id not in (step.id for step in steps)
      $rootScope.error = "The step that you were on is not visible in the current state."
      $state.go('start')
      return false
    return true

  $scope.starredDocPolling()
  $scope.refreshWorkflowSteps = ->
    Api.WorkflowStep.query({project: project.id}).$promise.then $scope.handleWorkflowSteps

  $scope.handleWorkflowSteps = (data) ->
    # if the user is logged out or logs in a someone else this, this poll will continue to work
    # responding with a 200 but gives back an empty array which leads to no step
    # rather than remove the current step and preventing the page from working we keep the old one
    # till we get new data
    if data.length > 0
      $scope.allWorkflowSteps = partitionAndSort(data, 'workflow', 'order')
      $scope.allSteps = partitionAndSort(data, 'id', 'order')
      if $scope.workflow
        $scope.steps = $scope.allWorkflowSteps[$scope.workflow.id]
      if $scope.step and $scope.checkStepIsStillVisible(data)
        $scope.step = $scope.allSteps[$scope.step.id]?[0]

  $scope.$on '$stateChangeSuccess', ->
    $scope.unselectAllDocs()
    polAllWorkflowSteps = polling endpoints.WorkflowStep, "project", project.id, $scope.handleWorkflowSteps

  $scope.$on '$destroy', ->
    polAllWorkflowSteps?.stop()

  # if we're only on the project then move to the workflow,
  # otherwise let workflow controller do its thing
  if $state.current.name == 'project'
    params =
      projectId: $scope.project.id
      workflowId: $scope.workflows[0].id
    $state.go('project.workflow', params)
